import { fg } from '@atlaskit/platform-feature-flags';
import { buildAtlAttributionHeaders } from '@atlassian/search-client/atl-attribution';
import { type ConfluenceLabel, confluenceLabelsQuery } from '@atlassian/search-client/label';

import { type CloudConfig } from '../../../../../../common/constants/filters/cloud-config/types';
import type {
	LookupFetcher,
	QueryParamsFetcher,
} from '../../../../../../common/constants/filters/select-filter/types';
import { ProductKeys } from '../../../../../../common/constants/products';

export const confluenceSearchLabels: LookupFetcher = async (query: string, config: CloudConfig) => {
	if (!config.intl || config.cloudId === undefined) {
		// base on existing interface, can only query contributors with intl
		return [];
	}

	if (fg('enable_labels_filter_confluence_dc_search')) {
		const product = config.product;
		if (product === ProductKeys.ConfluenceDC) {
			return [
				{
					trackingKey: query,
					value: query,
					label: query,
					queryParamValue: query,
					product: config.product,
				},
			];
		}
	}

	const headers = buildAtlAttributionHeaders({
		cloudId: config.cloudId,
		activationId: config.activationId,
		product: config.primaryProduct,
	});
	const initialLabelsResponse = await confluenceLabelsQuery(config.cloudId, query, 10, headers);

	const suggestedLabels: ConfluenceLabel[] =
		initialLabelsResponse.data?.confluence.searchLabels.suggestedLabels || [];
	const otherLabels: ConfluenceLabel[] =
		initialLabelsResponse.data?.confluence.searchLabels.otherLabels || [];

	return (
		[...suggestedLabels, ...otherLabels].map((label) => ({
			trackingKey: label.label || '',
			value: label.label || '',
			queryParamValue: label.label || '',
			label: label.label || '',
			product: config.product,
		})) ?? []
	);
};

export const confluenceQueryParamsFetcher: QueryParamsFetcher = async (queryParams) => {
	return queryParams.map((label) => ({
		trackingKey: label,
		value: label,
		queryParamValue: label,
		label: label,
	}));
};
